import { useSearchParams } from "react-router-dom";
import { useMigrationShowQuery } from "@/admin/entities/migrations";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

/**
 * Feature-специфичные хуки для управления миграциями
 */
export function useMigrationsManagement() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  useMigrationShowQuery(id, id === null);

  return {
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,
    getTableData,
    texts: getTextsConfig(),
  };
}
